'use client';

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { captureException } from '@sentry/nextjs';
import { Component } from 'react';
import { TweetNotFound } from 'react-tweet';
import { TweetBoundaryProps, TweetBoundaryState } from './types';
class TweetBoundary extends Component<TweetBoundaryProps, TweetBoundaryState> {
  state: TweetBoundaryState = {
    error: null
  };
  static getDerivedStateFromError(error: Error): TweetBoundaryState {
    return {
      error
    };
  }
  componentDidCatch(error: Error) {
    captureException(error, {
      tags: {
        slice: 'twitter_list'
      },
      extra: {
        tweetId: this.props.tweetId
      }
    });
  }
  render() {
    const {
      error
    } = this.state;
    const {
      children
    } = this.props;
    if (error) {
      return <TweetNotFound error={error} data-sentry-element="TweetNotFound" data-sentry-component="TweetBoundary" data-sentry-source-file="index.tsx" />;
    }
    return children;
  }
}
export default TweetBoundary;